// Bus simple para notificar expiración de sesión (401) desde axios al modal.
const EVENT = "conext:session-expired";
let dispatched = false;

export function notifySessionExpired() {
  if (dispatched) return;
  dispatched = true;
  try {
    window.dispatchEvent(new CustomEvent(EVENT));
  } catch (_) {}
}

export function onSessionExpired(handler) {
  const fn = () => handler();
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
}

export function resetSessionExpiredFlag() {
  dispatched = false;
}
